import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08a03302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-indicator" }

import Spinner from './Spinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingIndicator',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Spinner, { color: "#bbb" }),
    _createTextVNode(" Loading... ")
  ]))
}
}

})